import { Form, type FormItemProps, Input as AntdInputEmail, type InputProps as AntdInputEmailProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

interface InputEmailProps extends FormItemProps, AntdInputEmailProps, Ii18nLabel {
  name: string;
  children: any;
  onReset: any;
}

export const InputEmail = ({ name, label, i18nLabel, rules, disabled, type = 'email', ...props }: InputEmailProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item {...props} name={name} label={fieldLabel} rules={rules}>
      <AntdInputEmail disabled={disabled} type={type} />
    </Form.Item>
  );
};
